export const surveyContentFormatter = (results, survey) => {
  return Object.keys(results).map((questionName) => {
    const question = survey.getQuestionByName(questionName);
    return {
      questionTitle: question?.title,
      questionType: question?.getType(),
      questionAnswer: results[questionName],
      questionId: question?.name,
    };
  });
};
